
import { ActionCard, Container, Grid, Header, SpaceBetween, TruncatedText } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { mdiClipboardList } from '@mdi/js';
import Icon from '@mdi/react';
import React, { useEffect, useState } from 'react';
import { fetchWithWatch } from '../../hooks/fetchWithWatch';
import { buildBreadcrumbItems, getCookie, getUrlVersion } from '../../pages/commons/functions';
import { useGlobalState } from '../../pages/context/GlobalStateContext';
import { CustomAppLayout } from '../../pages/index/layout';
import { useRouter } from '../../pages/index/router';
import { iconMap, ItemNotification, MenuItem } from '../../resources/types';

const _preserve = React.version;

import "../../components/css/CardStyles.css";
// Add this line to debug the actual imported object
import { setData } from '../../pages/commons/functions';
import BadgeCounter from './BadgeCounter';

type CardItem = {
    badgeVariable: string;
    badgeColor: string;
    id: string;
    text: JSX.Element;
    description: string;
    href?: string;
    items?: MenuItem[];
    icon?: string;
};

export interface DefaultIndexProps {
}

/**
 * Spacer - a transparent div used to add vertical spacing.
 * If `height` is provided it will be strictly interpreted as pixels.
 */
export const DefaultIndex: React.FC<DefaultIndexProps> = ({

}) => {


    const { navigate } = useRouter();
    const [option, setOption] = useState<MenuItem | null>();
    const [badgeVariables, setBadgeVariables] = useState<string[]>([]);
    const [items, setItems] = useState<CardItem[]>([]);

    const { badgeData, getBadge, setBadge, clearBadge } = useBadgeData();

    const { idUser, data, menu, notifications, parameters } = useGlobalState();

    const handleOption = (ref: string) => {
        window.location.href = ref
    }

    const handleRefresh = async () => {
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/login/data',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ hash: window.location.hash.split('?')[0].replace("#", "") }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();

            if (dataWeb.code == 0) {
                if (dataWeb.counters) {
                    setData((prev: any) => ({
                        ...prev,
                        counters: dataWeb.counters
                    }));
                }
                //
            }
        } catch (error: any) {
        } finally { }
    }
    useEffect(() => {
        if (data && data.counters && data.counters.pax) setBadge("counterPax", data.counters.pax || 0);
        if (data && data.counters && data.counters.shifts) setBadge("counterShifts", data.counters.shifts || 0);
        if (data && data.counters && data.counters.polls) setBadge("counterPolls", data.counters.polls || 0);
    }, [data]);

    useEffect(() => {
        const matchedItems = findItemWithChildren(menu, window.location.hash);
        setOption(matchedItems);
        let subItems = subItemsToItems(matchedItems?.items ?? []);
        if (subItems) {
            setItems(subItems.filter(item => item.isHidden === 0));
        }

    }, [menu]);

    useEffect(() => {
    }, [option]);
    useEffect(() => {
        handleRefresh();
    }, []);
    function getNotificationInfo(href: string): ItemNotification {
        const notification = notifications.find(
            (n) => n.href === href && n.count > 0
        );
        if (!notification) return {
            count: 0,
            type: 'info',
            href: "",
            title: '',
            notification: '',
            color: '',
            date: '',
            time: '',
            day: '',
            idMessage: 0,
            loading: false
        };
        return {
            count: notification.count || 0,
            type: notification.type || 'info',
            href: notification.href || '',
            title: notification.title || '',
            notification: notification.notification || '',
            color: notification.color || '',
            date: notification.date || '',
            time: notification.time || '',
            day: notification.day || '',
            idMessage: notification.idMessage || 0,
            loading: false
        };
    }

    return (
        <CustomAppLayout
            toolsHide={true}

            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction='vertical' size='m'>
                        {/**
                        <Alert
                            action={<Favorites />}
                            type="info"
                            header={option?.text}
                        >
                            {option?.description}
                        </Alert>
                         */}
                        {option && option.icon !== "" && (
                            <Container
                                disableContentPaddings
                                media={{
                                    content: (<div style={{ paddingLeft: 10 }}>
                                        <Icon path={iconMap[option.icon || ""] as string} size={2.7} />
                                    </div>),
                                    position: "side",
                                }}
                                header={<Header variant='h3' description={option?.description}>{option?.text}</Header>}
                            />
                        )}
                        {option && option.icon === "" && (
                            <Container
                                disableContentPaddings
                                header={<Header variant='h3' description={option?.description}>{option?.text}</Header>}
                            />
                        )}
                        <Grid
                            gridDefinition={Array.from({ length: 12 }, () => ({
                                colspan: {
                                    default: 12, // Mobile: 1 column per row (full width)
                                    xxs: 12,     // Extra small screens
                                    xs: 6,       // Tablet: 2 columns per row
                                    s: 4,        // Small desktop: 3 columns per row
                                    l: 3,
                                }
                            }))}
                        >
                            {items.map(item => (
                                <ActionCard
                                    variant="default"
                                    href={item.href || window.location.hash}
                                    target={item.href && item.href.startsWith("#") ? "_self" : "_blank"}

                                    //description={getNotificationInfo(item.href)?.notification}
                                    icon={item.icon !== "mdiSoftLand" ?
                                        <Icon path={iconMap[item.icon?.trim() ?? ""] ?? ""} color={parameters.theme === "dark" ? "#c6c6cd" : "#000000"} size={1.5} /> :
                                        <MdiCustomSoftland size={1} color="#000000" />}
                                >

                                    <div>
                                        <h2 style={{ padding: 0, marginTop: 0, marginBottom: 5 }}>{item?.text || "Sin nombre"}
                                            {item.href && getNotificationInfo(item.href)?.count > 0 && (
                                                <BadgeCounter
                                                    top={5}
                                                    right={5}
                                                    color={getNotificationInfo(item.href)?.color} counter={getNotificationInfo(item.href)?.count} />
                                            )}</h2>
                                        <small><em><TruncatedText>{getNotificationInfo(item.href)?.notification || '\u00A0'}</TruncatedText></em></small>
                                        <p style={{
                                            margin: 0,
                                            padding: 0,
                                            height: "40px",
                                            overflow: "hidden",
                                            display: "-webkit-box",
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: "vertical",
                                            textOverflow: "ellipsis",
                                            verticalAlign: "top",
                                        }}>
                                            {item.description}
                                        </p>
                                    </div>
                                </ActionCard>
                            ))}

                        </Grid>



                    </SpaceBetween>
                </>
            }
        />
    );
};


const findItemWithChildren = (items: MenuItem[], hash: string): MenuItem | null => {
    for (const item of items) {
        if (item.href === hash) {
            // Found the target, return a shallow copy including its children
            return { ...item };
        }
        if (item.items) {
            const found = findItemWithChildren(item.items, hash);
            if (found) return found;
        }
    }
    return null;
};


const subItemsToItems = (subItems: MenuItem[]) => {
    return subItems.map((item) => {
        const iconPath = iconMap[item.icon || ""] || mdiClipboardList;
        return {
            id: item.href || item.idMenu?.toString() || 'unknown-id', // always string
            href: item.href,
            text: <span>{item.text || "Sin nombre"}</span>,
            description: item.description || "",
            icon: item.icon || "",
            badgeColor: item.badgeColor || "",
            badgeVariable: item.badgeVariable || "",
            isHidden: item.isHidden || 0,
        };
    });
};



function useBadgeData() {
    const [badgeData, setBadgeData] = useState<Record<string, number>>({});


    const getBadge = (key: string): number | undefined => badgeData[key];

    const setBadge = (key: string, value: number) => {
        setBadgeData(prev => ({ ...prev, [key]: value }));
    };

    const clearBadge = (key: string) => {
        setBadgeData(prev => {
            const updated = { ...prev };
            delete updated[key];
            return updated;
        });
    };

    return { badgeData, getBadge, setBadge, clearBadge };
}

export const MdiCustomSoftland = ({ size = 1, color = "black" }) => (
    <svg
        viewBox="0 0 48 44"
        style={{ width: `${size * 24}px`, height: 'auto', fill: color }}
    >
        <path d="M28.32,27.4l.2-.22-4.76-4.76-.22.25c-1.83,2.08-4.46,3.27-7.21,3.27-5.3,0-9.61-4.31-9.61-9.61s4.31-9.61,9.61-9.61c2.76,0,5.39,1.19,7.21,3.27l.22.25,4.76-4.76-.2-.22c-3.09-3.34-7.46-5.26-11.99-5.26C7.33,0,0,7.33,0,16.33s7.33,16.33,16.33,16.33c4.53,0,8.9-1.92,11.99-5.26Z" />
        <path d="M31.19,12.19c-4.53,0-8.9,1.92-11.99,5.26l-.2.22,4.76,4.76.22-.25c1.83-2.08,4.46-3.27,7.21-3.27,5.3,0,9.61,4.31,9.61,9.61s-4.31,9.61-9.61,9.61c-2.76,0-5.39-1.19-7.21-3.27l-.22-.25-4.76,4.76.2.22c3.09,3.34,7.46,5.26,11.99,5.26,9.01,0,16.33-7.33,16.33-16.33s-7.33-16.33-16.33-16.33Z" />
    </svg>
);